import { BANNER_NLS_HEIGHT } from './BannerNLS';

const getSpotlightInputDimensions = (
	spotlightInputRef: React.RefObject<HTMLInputElement | null>,
) => {
	if (!spotlightInputRef.current) {
		return { height: 0, bottom: 0 };
	}

	const rect = spotlightInputRef.current.getBoundingClientRect();

	return { height: rect.height, bottom: rect.bottom };
};

// Calculate available space from the bottom of the spotlight input to the bottom of the viewport
export const getAvailableSpaceForDropdown = (spotlightBottomPosition: number) => {
	const viewportHeight = window.innerHeight;
	const FOOTER_BUTTONS_HEIGHT = 37;
	const BOTTOM_MARGIN = 10;

	const availableSpace =
		viewportHeight - spotlightBottomPosition - FOOTER_BUTTONS_HEIGHT - BOTTOM_MARGIN;

	return availableSpace > 0 ? availableSpace : 0;
};

const DROPDOWN_MAX_HEIGHT = 960;
const SEARCH_OPTIONS_HEIGHT = 72;

export const getSpotlightDropdownDimensions = (
	spotlightInputRef: React.RefObject<HTMLInputElement | null>,
	hasNLSBanner: boolean,
	hasSearchOptions: boolean,
) => {
	const { bottom: spotlightBottomPosition, height: spotlightInputHeight } =
		getSpotlightInputDimensions(spotlightInputRef);

	const availableSpace = getAvailableSpaceForDropdown(spotlightBottomPosition);

	const dropdownMaxHeight = Math.min(availableSpace, DROPDOWN_MAX_HEIGHT);

	// For innerDivMaxHeight we don't need to take into account the help footer because the innerDiv has a bottom padding to accommodate it
	const innerDivMaxHeight =
		dropdownMaxHeight -
		(hasNLSBanner ? BANNER_NLS_HEIGHT : 0) -
		(hasSearchOptions ? SEARCH_OPTIONS_HEIGHT : 0);

	const DROPDOWN_TOP_OFFSET_FROM_INPUT = 4;
	const dropdownTop = spotlightInputHeight + DROPDOWN_TOP_OFFSET_FROM_INPUT;

	return { dropdownMaxHeight, innerDivMaxHeight, dropdownTop };
};
